export default __webpack_public_path__ + "assets/certificates/Steel_rope_mill's_quality.164d02dc.pdf";